export default __webpack_public_path__ + "static/media/upload-placeholder.1a1fd643.svg";